import ApiService from "@/services/api.service"

export const AccountingService = {
  salaries(id) {
    return ApiService.get(`accounting/${id}/salaries`)
  },
  materials(id) {
    return ApiService.get(`accounting/${id}/materials`)
  },
  clearSalaryPayments(month_id, user_id) {
    return ApiService.delete(`accounting/salary/clean/${user_id}/${month_id}`)
  },
  closeMonth(month_id) {
    return ApiService.post(`accounting/${month_id}/close`)
  },
  openMonth(month_id) {
    return ApiService.post(`accounting/${month_id}/open`)
  },
  salaryAdjustment(month_id, params) {
    return ApiService.post(`accounting/${month_id}/salary/adjustment`, params)
  },
  recountUserSalary(month_id, user_id) {
    return ApiService.post(`accounting/${month_id}/salary/recount`, { user_id })
  }
}
